import { Box, SxProps } from "@mui/material";
import { ElementType } from "react";
import { useTranslation } from "react-i18next";
import { useAvailableLanguagesLabel } from "../../hooks";

type IAvailableLanguages = {
  availableLanguages?: string[]
  component: ElementType
  sx?: SxProps
}

export function AvailableLanguages({
  availableLanguages,
  component: Component,
  sx
}: IAvailableLanguages) {
  const { t } = useTranslation();
  const label = useAvailableLanguagesLabel(availableLanguages);

  if (!label) return null;

  return (
    <Component sx={ sx }>
      <Box component="span" sx={ { fontWeight: 700 } }>
        { t("available_languages") }
      </Box>
      { " " }{ label }
    </Component>
  );
}
